/**
 * The only source types evidence and board attachments accept. SVG is deliberately absent:
 * it is XML that can carry script and executes when a browser renders it, so it is refused
 * here, in the media commit processor and in the Storage rules alike.
 */
export const ACCEPTED_SOURCE_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export function isAcceptedSourceImageType(value) {
    return (typeof value === 'string' && ACCEPTED_SOURCE_IMAGE_TYPES.includes(value));
}
export function validateImage(input) {
    const errors = [];
    const warnings = [];
    const longEdge = Math.max(input.width, input.height);
    const shortEdge = Math.min(input.width, input.height);
    if (!input.decoded)
        errors.push('IMAGE_DECODE_FAILED');
    if (input.width <= 0 || input.height <= 0)
        errors.push('IMAGE_DIMENSIONS_INVALID');
    if (longEdge < (input.minimumLongEdge ?? 960) || shortEdge < (input.minimumShortEdge ?? 540)) {
        errors.push('IMAGE_TOO_SMALL');
    }
    if (input.blurScore !== undefined && input.blurScore < (input.blurWarningBelow ?? 80)) {
        warnings.push('IMAGE_MAY_BE_BLURRY');
    }
    return {
        accepted: errors.length === 0,
        errors,
        warnings,
        width: input.width,
        height: input.height,
        ...(input.blurScore === undefined ? {} : { blurScore: input.blurScore }),
    };
}
/** Variance of a 4-neighbour Laplacian. Use on a small grayscale sample for low mobile CPU cost. */
export function calculateBlurScore(luma, width, height) {
    if (width < 3 || height < 3 || luma.length < width * height)
        return 0;
    let sum = 0;
    let sumSquares = 0;
    let count = 0;
    for (let y = 1; y < height - 1; y += 1) {
        for (let x = 1; x < width - 1; x += 1) {
            const i = y * width + x;
            const value = 4 * luma[i] - luma[i - 1] - luma[i + 1] - luma[i - width] - luma[i + width];
            sum += value;
            sumSquares += value * value;
            count += 1;
        }
    }
    if (count === 0)
        return 0;
    const mean = sum / count;
    return sumSquares / count - mean * mean;
}
